import type { AppThunk } from "@Store/index";
import getCustomPageData from "../helpers/getCustomPageData";
import {
  getUniversityPageRequesting,
  getUniversityPageSuccess,
  getUniversityPageFailure,
} from "./universityPageReducer";

const getUniversityPageData =
  (partnerIdentifier: string, staticContext?: any): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getUniversityPageRequesting(""));

      const response = await getCustomPageData(partnerIdentifier);
      const firstPage = response.data?.data?.result?.[0];

      if (firstPage?.config) {
        dispatch(
          getUniversityPageSuccess({
            slug: firstPage.slug || "",
            config: firstPage.config,
            enabled: firstPage.enabled ?? true,
          }),
        );
      } else {
        dispatch(getUniversityPageFailure("No custom pages found"));
        if (staticContext) {
          staticContext.statusCode = 404;
        }
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch page data";
      dispatch(getUniversityPageFailure(errorMessage));

      if (error.response?.status === 404 || error.response?.data?.status === "not_found") {
        if (staticContext) {
          staticContext.statusCode = 404;
        }
      }
    }
  };

export default getUniversityPageData;
